// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2FV1H","containerItemsCenter":"Skeleton_containerItemsCenter__1LWvZ"};